import React from 'react';
import './TextAreaModal.css';

//A modal for editing and saving textarea data, with save and cancel buttons


export class AppModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
      }
    
      //Changeevent when value is changed in modal textfield
      handleChange(e) {
        const post = e.target.value;
        this.props.onChange(post);
      }

      //Onclick event for modal's cancel button
      handleCancel(e)
      {
          const cancel = e.target.value;
        this.props.cancelPost(cancel);
      }

      //Onclick event for modal's save button
      handleSave(e)
      {
          const post = e.target.value;
          this.props.savePost(post);
      }
  


render()
{
    return(
        <div className = "Modal">
        <p> Post </p>
        <textarea value={this.props.post} onChange={this.handleChange} />

        <button className="btn btno btn-warning" value={this.props.onLoadPost} onClick={this.handleCancel}> Cancel </button>
        <button  className="btn btno btn-info" value={this.props.post} onClick={this.handleSave}> Save </button>
        </div>
    )
};

}

export default AppModal;



// WEBPACK FOOTER //
// ./src/Components/Modals/TextAreaModal.js